import React from 'react';
import PropTypes from 'prop-types';
import {Title} from './Title';
import {NodeHolder} from '../NodeHolder';
import './style.scss';

/**
 * NodeGroup: Component that group a couple of Nodes in
 * 						DesignSlideThree to create a Group with a specific color
 */
export function NodeGroup(props) {
  const setStyle = () => ({
    backgroundColor: props.groupColor,
  });

  const renderNode = (node) =>
    React.cloneElement(props.nodeHolder, {
      key: node.nodeId,
      groupId: props.groupId,
      dropComponent: NodeHolder.SlideThreeOption,
      ...node,
    });
  return (
    <div className='nodeGroup' style={setStyle()}>
      <Title title={props.label} />
      {props.groupNodes.map(renderNode)}
    </div>
  );
}

NodeGroup.propTypes = {
  /**
   * UniqueId for the Group
   */
  groupId: PropTypes.number.isRequired,
  /**
   * Label for the Group
   */
  label: PropTypes.string.isRequired,
  /**
   * Hex Color value associated with the Group
   */
  groupColor: PropTypes.string.isRequired,
  /**
   * List of Node items in the Group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * List of feedback messages
       */
      errorFeedbacks: PropTypes.arrayOf(PropTypes.string),
      /**
       * Id of component dropped in Node
       */
      droppedId: PropTypes.number,
      /**
       * Object contains details of option currently
       * dropped in the node.
       */
      droppedOption: PropTypes.shape({
        /**
         * Unique Id of the dropped option
         */
        id: PropTypes.number.isRequired,
        /**
         * Text to dispaled on the option
         */
        text: PropTypes.string.isRequired,
        /**
         * Color hex value for the option
         */
        groupColor: PropTypes.string.isRequired,
      }),
      /*
       * placeholder message to show if no option is dropped
       */
      placeholder: PropTypes.string,
      /**
       * Unique Id for the node
       */
      nodeId: PropTypes.number,
      /**
       * Counter for number for error attempts,
       * Used to select appropriate feedback message
       */
      wrongAttempts: PropTypes.number.isRequired,
    })
  ),
  /**
   * The element to be used as the NodeHolder
   */
  nodeHolder: PropTypes.element.isRequired,
};

NodeGroup.defaultProps = {
  groupId: null,
  label: '',
  groupNodes: [],
  groupColor: '#ffffff',
};
